import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

const BASE = `${API}expenses/categories/`;

const ExpenseCategoryService = {
  getCategories: (query) => {
    let url = `${BASE}?per_page=${query.pageSize}&page=${query.page + 1}`;

    if (query.search) {
      url += `&search=${query.search}`;
    }

    if (query.orderBy) {
      url += `&orderBy=${query.orderBy.field}`;
      url += `&orderDirection=${query.orderDirection}`;
    }

    return axios.get(url, { headers: authHeader() });
  },

  getCategory: (id) =>
    axios.get(`${BASE}${id}/`, { headers: authHeader() }),

  createCategory: (data) =>
    axios.post(BASE, data, { headers: authHeader() }),

  updateCategory: (id, data) =>
    axios.put(`${BASE}${id}/`, data, { headers: authHeader() }),

  deleteCategory: (id) =>
    axios.delete(`${BASE}${id}/`, { headers: authHeader() }),
};

export default ExpenseCategoryService;
